// frontend/src/components/common/NotFoundPage.js
import React from 'react';
import { Container, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Home, Search, ArrowRight } from 'react-feather';
import '../assets/css/NotFoundPage.css';

const NotFoundPage = ({ 
  title = "¡Ups! No encontramos al creador que buscas",
  message = "El perfil que buscas no existe o no está disponible.",
  showHomeButton = true,
  showSearchButton = true
}) => {
  return (
    <div className="not-found-page">
      <Container className="not-found-container">
        {/* Elemento decorativo */}
        <div className="not-found-shape shape-1"></div>
        <div className="not-found-shape shape-2"></div>
        <div className="not-found-shape shape-3"></div>
        
        {/* Contenido principal */}
        <div className="not-found-content">
          {/* Icono/Ilustración */}
          <div className="not-found-icon">
            <span className="emoji-big">🔍</span>
          </div>
          
          {/* Código de error */}
          <div className="not-found-code">
            <span className="code-404">404</span>
          </div>
          
          {/* Título */}
          <h1 className="not-found-title">
            {title}
          </h1>
          
          {/* Mensaje */}
          <p className="not-found-message">
            {message}
          </p>
          
          {/* Sugerencias */}
          <div className="not-found-suggestions">
            <p className="suggestions-title">¿Qué podés hacer?</p>
            <ul className="suggestions-list">
              <li>Verificar que la dirección sea correcta</li>
              <li>El creador puede haber cambiado su nombre de usuario</li>
              <li>El perfil podría haber sido eliminado</li>
            </ul>
          </div>
          
          {/* Botones de acción */}
          <div className="not-found-actions">
            {showHomeButton && (
              <Link to="/">
                <Button variant="primary" className="action-btn">
                  <Home size={18} className="me-2" />
                  Ir al inicio
                </Button>
              </Link>
            )}
            
            {showSearchButton && (
              <Link to="/explore">
                <Button variant="outline-primary" className="action-btn">
                  <Search size={18} className="me-2" />
                  Explorar perfiles
                </Button>
              </Link>
            )}
            
            <Link to="/login">
              <Button variant="link" className="create-btn">
                Crear tu perfil
                <ArrowRight size={16} className="ms-1" />
              </Button>
            </Link>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default NotFoundPage;